import { Networks } from "./blockchain";

const AVAX_MAINNET = {
    DB_MIM_ADDRESS: "0x1ab6844e765335c94d749e73bedd8d228bc9f1d0",
    DB_AVAX_ADDRESS: "0xe4d460aba520d0016c4ff5d321e54b3e6ce54866",
    DAO_ADDRESS: "0xDc6eA2393fc53B5822c728a5479d809b529519Cb",
    SDB_ADDRESS: "0xA219D088Fdd958ED30aF8a9b85c82e188260D237",
    DB_ADDRESS: "0x3B760B2527a4C2bb5E0F2B9e7BC77744adE2484E",
    MIM_ADDRESS: "0x130966628846bfd36ff31a822705796e8cb8c18d",
    STAKING_ADDRESS: "0x80f75237559aCB7B9A0f09a2a54509E328D4f715",
    STAKING_HELPER_ADDRESS: "0xB993fE46d02580a43E9163946E66cb1698541737",
    DB_BONDING_CALC_ADDRESS: "0xf5E72b5e6E73a0614a7bfe74Aa053CF9AcAbc7c5",
    TREASURY_ADDRESS: "0x7212A824A45dA0eeF1681a96F119414A0cC1bA27",
    ZAPIN_ADDRESS: "0x9ABE63C5A2fBcd54c8bAec3553d326356a530cae", //"0xb98007C04f475022bE681a890512518052CE6104",
    WDB_ADDRESS: "0xD936fA3Fec181AfbD0c4D3798ADfAFC39523c1e4",
};

const AVAX_TESTNET = {
    DB_MIM_ADDRESS: "0xc7d96be44090d8a25c0d52733e22ddfd57ae4004",
    DB_AVAX_ADDRESS: "0x439d25a6f91c0342d54b63ec1e3b9a079a45fdaf",
    DAO_ADDRESS: "0x1EF0272BDBd9b522769a832665dB1F368Eb5de78",
    SDB_ADDRESS: "0x00875eC07F3a443c19Dd6002C38B88ED9d221E2d",
    DB_ADDRESS: "0xb392c73e48147BEB3EAAA315C2b41D330b2181f0",
    MIM_ADDRESS: "0xfE162B97497dB5942604833Cba13E57A66Ce0391",
    STAKING_ADDRESS: "0xB60D02Dfd76fCbD842c7B4A012Aac9C2116F102e",
    STAKING_HELPER_ADDRESS: "0x1a06F3f973921fBC6E370F7965c906d0f8f29C26",
    DB_BONDING_CALC_ADDRESS: "0x06ac77c7Ae6279F1773fC5030F45D6CC056b6a0d",
    TREASURY_ADDRESS: "0x155b70E6eA0395E2BCd1198498C7B05D6D1e6128",
    ZAPIN_ADDRESS: "0x9ABE63C5A2fBcd54c8bAec3553d326356a530cae",
    WDB_ADDRESS: "0x89F6AE694E793A30f56f3B60534BDCaf2Aad1317",
};

export const getAddresses = (networkID: number) => {
    if (networkID === Networks.AVAX) return AVAX_MAINNET;
    if (networkID === Networks.FUJI) return AVAX_TESTNET;

    throw Error("Network don't support");
};
